import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';

import { State } from '../../../vista-usuario/vista-usuario.state';

@Component({
  selector: 'rpe-vista-nuevo-vinculo-container',
  templateUrl: './vista-nuevo-vinculo-container.component.html',
  styleUrls: ['./vista-nuevo-vinculo-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaNuevoVinculoContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {    
  }
}
